import { RowValueFlag, DocumentFlag } from '@/types/flags'
import { CircularProgress, Divider, Stack, SxProps } from '@mui/material'
import FullFlagsList from './FullFlagsList'

type FlagsDialogProps = {
  documentFlags: DocumentFlag[]
  rowValueFlags: RowValueFlag[]
  isLoading?: boolean
  onRowValueFlagClick?: (
    flag: RowValueFlag,
    cellToFocus: HTMLInputElement | HTMLDivElement | null,
  ) => void
  sx?: SxProps
}

export default function FlagList({
  documentFlags = [],
  rowValueFlags = [],
  isLoading = false,
  onRowValueFlagClick,
  sx,
}: FlagsDialogProps) {
  const hasDocumentFlags = documentFlags.length > 0
  const hasRowValueFlags = rowValueFlags.length > 0

  return (
    <Stack spacing={2} sx={sx}>
      {isLoading ? (
        <CircularProgress sx={{ alignSelf: 'center' }} />
      ) : (
        <>
          {hasDocumentFlags && (
            <FullFlagsList title="Document Flags" flags={documentFlags} />
          )}
          {hasDocumentFlags && hasRowValueFlags && <Divider />}
          {hasRowValueFlags && (
            <FullFlagsList
              title="Field Flags"
              flags={rowValueFlags}
              onFlagClick={onRowValueFlagClick}
            />
          )}
        </>
      )}
    </Stack>
  )
}
